export default __webpack_public_path__ + "media/src/features/mobile-search-action/assets/search_white-4e3816d8b2200a5a8d051f940765ef95.svg";